(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQuuke = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.ukapplication === "undefined") {
        jQuery.extend(sm.portal.vm, { ukapplication: {} });
    }

    function InitializeSections (application, coreSections) {
        var ukSections = [] ;
        var qualificationsOnEntryModel = new sm.portal.vm.QualificationsOnEntryViewModel();
        var languagesModel = new sm.portal.vm.LanguagesViewModel();
        var accessibilityNeedModel = new sm.portal.vm.AccessibilityNeedViewModel();
        var applicationInformationModel = new sm.portal.vm.ApplicationInformationViewModel();
        var MakeSectionsRequired = {
            SetLanguagesRequired : ko.observable(false),
            SetAccessibilityNeedRequired : ko.observable(false),
            QualificationsAppearanceOrder : ko.observable(91),
            SetQualificationsRequired : ko.observable(false),
            SetQualificationsCompleted : ko.observable(true),
            ApplicationInformationAppearanceOrder : ko.observable(92),
            SetApplicationInformationCompleted : ko.observable(true)
        }
        sm.portal.vm.custom.setCustomLocalizeKey(MakeSectionsRequired);    

        // Languages
        ukSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 62,
            SectionName: 'Languages',
            SectionTitle: sm.portal.utility.getResourceValue('Languages'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Languages'),
            Applied: true,
            Completed: false,
            Required: MakeSectionsRequired.SetLanguagesRequired(),
            SectionModel: languagesModel,
            SectionTemplate: "LanguagesTemplate.UK"
        }));

        // Accessibility Needs
        ukSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 63,
            SectionName: 'AccessibilityNeed',
            SectionTitle: sm.portal.utility.getResourceValue('AccessibilityNeeds'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Accessibility'),
            Applied: true,
            Required: MakeSectionsRequired.SetAccessibilityNeedRequired(),
            SectionModel: accessibilityNeedModel,
            SectionTemplate: "AccessibilityNeedTemplate.UK"
        }));
        // Qualifications On Entry
        ukSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: MakeSectionsRequired.QualificationsAppearanceOrder(),
            SectionName: 'QualificationsOnEntry',
            SectionTitle: sm.portal.utility.getResourceValue('Qualifications'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Qualifications'),
            Applied: true,
            Required: MakeSectionsRequired.SetQualificationsRequired(),
            Completed: MakeSectionsRequired.SetQualificationsCompleted(),
            SectionModel: qualificationsOnEntryModel,
            SectionTemplate: "QualificationsOnEntryTemplate"
        }));
        // Application Information
        ukSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: MakeSectionsRequired.ApplicationInformationAppearanceOrder(),
            SectionName: 'ApplicationInformation',
            SectionTitle: sm.portal.utility.getResourceValue('ApplicationInformation'),
            SectionNavTitle: sm.portal.utility.getResourceValue('ApplicationInformation'),
            Applied: true,
            Required: false,
            Completed: MakeSectionsRequired.SetApplicationInformationCompleted(),
            SectionModel: applicationInformationModel,
            SectionTemplate: "ApplicationInformationTemplate.UK"
        }));

        application.LastSectionName('ApplicationInformation');

        coreSections = coreSections.filter(function(e) { 
            return e.SectionName() !== 'College' &&  e.SectionName() != 'TestScore';
        });

        return coreSections.concat(ukSections);
    }

    function MoveToNextSection(application, nextSectionObj){
        if (nextSectionObj != null) {
            if (application.CurrentSectionName() === "Academic") {
                var isValid = application.GetSectionModel('Academic').ValidateModel();
                if (isValid) {
                    nextSectionObj.Active(true);
                }
            }
        }
    }

    function ExtractATO(application, submitModel, stdAttempt, stdPerson){
        
        var basicContactSecData = application.GetSectionModel('BasicContact');
        var languageSecData = application.GetSectionModel('Languages');
        var accessibilityNeedSecData = application.GetSectionModel('AccessibilityNeed');
        var applicationInformationSecData = application.GetSectionModel('ApplicationInformation');
        var qualificationsOnEntrySecData = application.GetSectionModel('QualificationsOnEntry');
        var demographicSecData = application.GetSectionModel('Demographic');

        var accessibilityNeedData = accessibilityNeedSecData.ExtractATO();

        var accessibilityNeedModel = Array();
        var disabledStudentAllowanceInformation = Array();
        for (var i = 0; i < accessibilityNeedData.length; i++) {
            accessibilityNeedModel.push(accessibilityNeedData[i].AccessibilityNeedModel);
            disabledStudentAllowanceInformation.push(accessibilityNeedData[i].DisabledStudentAllowanceInformation);
        }

         // Construct the Hesa Student fields object

         var genderIdentityID = "0";
         var sexualOrientationID = "0";
         var disabledStudentAllowanceID = "0";

         if (!sm.portal.utility.isNullOrEmpty(demographicSecData.GenderIdentityID()) && demographicSecData.GenderIdentityID() > 0) {
             genderIdentityID = demographicSecData.GenderIdentityID();
         }
         if (!sm.portal.utility.isNullOrEmpty(demographicSecData.SexualOrientationID()) && demographicSecData.SexualOrientationID() > 0) {
             sexualOrientationID = demographicSecData.SexualOrientationID();
         }
         if (!sm.portal.utility.isNullOrEmpty(demographicSecData.GenderID()) && demographicSecData.GenderID() > 0) {
            var customData = {
                stdPerson : stdPerson,
                demographicSecData : demographicSecData        
            } 
            sm.portal.vm.custom.callCustomization('SetGenderIDForUKExtractATO', customData, 
                function () {
                    submitModel.PersonalInformation.GenderID = demographicSecData.GenderID();                    
                }
            );
         }

         for (var i = 0; i < disabledStudentAllowanceInformation.length; i++) {

             if (!sm.portal.utility.isNullOrEmpty(disabledStudentAllowanceInformation[i].DisabledStudentAllowanceID) && disabledStudentAllowanceInformation[i].DisabledStudentAllowanceID > 0) {
                 disabledStudentAllowanceID = disabledStudentAllowanceInformation[i].DisabledStudentAllowanceID;
             }
         }

         var hesaStudentFields = '{"GenderIdentityID": "';
         hesaStudentFields += genderIdentityID;
         hesaStudentFields += '", "SexualOrientationID": "';
         hesaStudentFields += sexualOrientationID;
         hesaStudentFields += '", "DisabledStudentAllowanceID": "';
         hesaStudentFields += disabledStudentAllowanceID;
         hesaStudentFields += '"}';

         // Construct the Hesa Student Qualifications object

         var qualificationsOnEntryData = qualificationsOnEntrySecData.ExtractATO();

         var qualificationsOnEntry = Array();

         for (var i = 0; i < qualificationsOnEntryData.length; i++) {
             var qualificationTypeID = "0";
             var qualificationSubjectID = "0";
             var qualificationSittingID = "0";
             var qualificationYear = "";
             var qualificationGrade = "";

             if (!sm.portal.utility.isNullOrEmpty(qualificationsOnEntryData[i].QualificationTypeID) && qualificationsOnEntryData[i].QualificationTypeID > 0) {
                 qualificationTypeID = qualificationsOnEntryData[i].QualificationTypeID;
             }

             if (!sm.portal.utility.isNullOrEmpty(qualificationsOnEntryData[i].QualificationSubjectID) && qualificationsOnEntryData[i].QualificationSubjectID > 0) {
                 qualificationSubjectID = qualificationsOnEntryData[i].QualificationSubjectID;
             }

             if (!sm.portal.utility.isNullOrEmpty(qualificationsOnEntryData[i].QualificationSittingID) && qualificationsOnEntryData[i].QualificationSittingID > 0) {
                 qualificationSittingID = qualificationsOnEntryData[i].QualificationSittingID;
             }

             if (!sm.portal.utility.isNullOrEmpty(qualificationsOnEntryData[i].QualificationYear)) {
                 qualificationYear = qualificationsOnEntryData[i].QualificationYear;
             }

             if (!sm.portal.utility.isNullOrEmpty(qualificationsOnEntryData[i].QualificationGrade)) {
                 qualificationGrade = qualificationsOnEntryData[i].QualificationGrade;
             }

             var hesaQualificationResultsFields = '{"QualificationTypeID": "';
             hesaQualificationResultsFields += qualificationTypeID;
             hesaQualificationResultsFields += '", "QualificationSubjectID": "';
             hesaQualificationResultsFields += qualificationSubjectID;
             hesaQualificationResultsFields += '", "QualificationSittingID": "';
             hesaQualificationResultsFields += qualificationSittingID;
             hesaQualificationResultsFields += '", "QualificationYear": "';
             hesaQualificationResultsFields += qualificationYear;
             hesaQualificationResultsFields += '", "QualificationGrade": "';
             hesaQualificationResultsFields += qualificationGrade;
             hesaQualificationResultsFields += '"}';

             qualificationsOnEntry.push(hesaQualificationResultsFields);
         }

        // Construct the Language ATO object        
        submitModel.LanguagesInformation=  ko.toJS(languageSecData.ExtractATO());
        // Construct the Accessibility Need ATO object        
        submitModel.AccessibilityNeedsInformation = ko.toJS(accessibilityNeedModel);

        submitModel.HesaStudentFields = hesaStudentFields;
        submitModel.HesaStudentQualificationFields = ko.toJS(qualificationsOnEntry);

        var applicationInformationData = applicationInformationSecData.ExtractATO();
        stdAttempt.AdmissionsAttemptUKAdditionalInfo.push(applicationInformationData.ApplicationInformation);
        stdAttempt.AdmissionsAttemptUKPersonalStatement.push(applicationInformationData.PersonalStatement);

        submitModel.AdmissionsInformation = ko.toJS(stdAttempt);

        if (basicContactSecData.PermanentMailingAddress().ExtractATO() != null && basicContactSecData.showPermanentMailingAddress() === true) {
            submitModel.PersonalInformation.Addresses.push(basicContactSecData.PermanentMailingAddress().ExtractATO());
        }
        var customData = {
            submitModel : submitModel,
            languageSecData : languageSecData    
        }
        sm.portal.vm.custom.callCustomization('SetExtractATOForLanguageAssessment', customData);
        return submitModel;
    }


    jQuery.extend(true, sm.portal.vm.ukapplication, {
        InitializeSections: InitializeSections,
        MoveToNextSection: MoveToNextSection,
        ExtractATO: ExtractATO
    });

})(jQuery);